import { render, staticRenderFns } from "./pageAdministration.vue?vue&type=template&id=593dd597&scoped=true"
import script from "./pageAdministration.vue?vue&type=script&lang=js"
export * from "./pageAdministration.vue?vue&type=script&lang=js"
import style0 from "./pageAdministration.vue?vue&type=style&index=0&id=593dd597&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593dd597",
  null
  
)

export default component.exports